import { mediaPipelineQueryKeys as e } from "./useMediaPipelineQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { adminMediaPipelineApi as n } from "@maat/api-main";
//#region src/mediaPipeline/useMediaPipelineFailuresQuery.ts
var r = (r) => t({
	queryKey: e.failures(r?.window, r?.kind, r?.workspaceId),
	fetchPage: (e) => n.listFailures({
		window: r?.window,
		kind: r?.kind,
		workspace_id: r?.workspaceId,
		page: e
	}),
	key: "items"
});
//#endregion
export { r as useMediaPipelineFailuresQuery };
